import { ShieldCheck } from 'lucide-react';
import type { ReactNode } from 'react';

export interface ShieldNoteProps {
  children: ReactNode;
  className?: string;
}

/** Shield icon + grey microcopy ("Your data is encrypted and never shared without consent."). */
export function ShieldNote({ children, className = '' }: ShieldNoteProps) {
  return (
    <p className={`flex items-center justify-center gap-1.5 text-xs text-slate ${className}`.trim()}>
      <ShieldCheck aria-hidden="true" size={14} className="shrink-0 text-dkgreen" />
      {children}
    </p>
  );
}
